// extracted by mini-css-extract-plugin
export var defaultCursor = "BreadCrumb-module--defaultCursor--r2WsJ";
export var grey = "BreadCrumb-module--grey--N+JVT";
export var text = "BreadCrumb-module--text--ZFN+u";